/**
 * 대표 도메인(canonical host) 강제
 *
 * www.koreacarers.com 으로 들어온 요청을 koreacarers.com 으로 보냅니다.
 *
 * 실제 301 은 Cloudflare Redirect Rule 이 담당하고(서버 레벨, 검색엔진이 즉시 인식),
 * 이 함수는 그 규칙이 빠졌거나 다른 호스팅으로 옮겨졌을 때를 위한 안전장치입니다.
 *
 * - apex(www 없는 주소)로 들어오면 아무 것도 하지 않습니다.
 * - localhost / pages.dev / preview 주소에서는 절대 동작하지 않습니다.
 */

const CANONICAL_HOST = 'koreacarers.com';
const WWW_HOST = `www.${CANONICAL_HOST}`;

export function shouldRedirectToCanonicalHost(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.toLowerCase() === WWW_HOST;
}

export function redirectToCanonicalHost(): void {
  if (!shouldRedirectToCanonicalHost()) return;

  const { protocol, pathname, search, hash } = window.location;
  const target = `${protocol}//${CANONICAL_HOST}${pathname}${search}${hash}`;

  // replace 로 이동해야 브라우저 뒤로가기에 www 주소가 남지 않습니다.
  window.location.replace(target);
}